import axios from 'axios'

const IP_DOMAIN = 'https://ipapi.co/json/'

export interface IIP {
    ip: string
    city: string
    region: string
    region_code: number
    country_name: string
    country_capital: string
    postal: number
    utc_offset: string
    currency: string
}

const ipService = {
    getIP: () => axios.get<IIP>(IP_DOMAIN),
}

export default ipService
